import i18n from './i18n'

export function installPlugins(app) {
  i18n(app)
}